/**
 * Zoom Module
 * 
 * @description
 * <p>Handles mouseover image zoom functionality (mostly on History page images)</p>
 * <p>On page load, adds mouse events to all .zoom elements.</p>
 * <p>Self-initializes when you include this module.</p>
 * 
 * @module zoom
 *
 * @namespace site.zoom
 */
( /* @lends module:zoom */ function(site,$){
	"use strict";
(function($){
	var trace = {push: function() {}},
		dom = {};

	function init() {
		trace = site.utilities && site.utilities.trace ? site.utilities.trace : {push: function() {}};

		// Find all images that need to zoom
		dom.zoom = $('.zoom');

		// add hover and zoom events to zoom images
		dom.zoom.each(function(){
			set($(this));	

		});


	}
	function set(obj) {
		obj.on('mouseover', function() {
			if (!site.checkMobile()) $(this).addClass('active');

		}).on('mouseleave', function() {

			$(this).removeClass('active');

		}).on('mousemove', function(event) {

			var active = $(this).hasClass('active');
			var imgX = ((event.pageX - $(this).offset().left) / $(this).width()) * 100;
			var imgY = ((event.pageY - $(this).offset().top) / $(this).height()) * 100;
			var origin = imgX+"% "+imgY+"%";
			trace.push("imgX "+imgX+" imgY = "+imgY);
			if(active) $(this).find('img').css({"transform-origin":origin});

		});	

	}


	// Public API definitions
	site.zoom = {
		set : set
	};


	$(function(){
		init();
	});
	})(jQuery);
})(window.site=window.site || {}, jQuery);
